const getLogin = (state) => state.login;
export const getLocale = (state) => getLogin(state).locale;
